export const API_PATHS = {
    PSP: {
        GVIEW: {
            BY_ID: (id: string) => `/psp/gview/${id}`,
        },
        PROJECT: {
            DATASET: (projectId: string) => `/psp/api/v1/Project/${projectId}/Dataset/ListEU`,
        },
        DATASET: {
            PANORAMAS: (projectId: string, datasetId: string) =>
                `/psp/api/v1/project/${projectId}/dataset/${datasetId}/panoramas`,
        },
        DL: {
            DATASET_CHANK: (projectId: string, datasetItemId: string) =>
                `/psp/dl/dataset/p/${projectId}/d/${datasetItemId}/chk`,
            DATASET_DATA: (projectId: string, datasetItemId: string, fileName: string) =>
                `/psp/dl/dataset/p/${projectId}/d/${datasetItemId}/data/${fileName}`,
        },
        VIEW: {
            SHARE_DATA: (pucKey: string) => `/psp/view/sh/${pucKey}`,
        },
    },
};
